import React, { useEffect, useState} from "react";
import styled from 'styled-components';
import copy from '../../styles/assets/blue_copy.svg';

import { GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY } from "../../constants/storage_constats";
import UserWalletOptionMenuComponent from "./UserWalletOptionMenuComponent";

import 'react-toastify/dist/ReactToastify.css';
import GlipWalletGlobal from '../../services/walletService';

import { eventTracker } from "../../services/eventTracker";
import { getAssetTransfers } from "../../services/activityHelper";
import BalanceComponent from "./BalanceComponent";
import OffRampLinkComponent from "../OffRampComponents/OffRampLinkComponent";

import { useTranslation } from "react-i18next";

import {copyText} from '../../utils/copyText';
import SeedPhraseComponent from "./SeedPhraseComponent";
import TokenListItemComponent from "./TokenListComponent";
import AddNFTItemComponent from "./AddNFTItemComponent";

import ActivityListComponent from "./ActivityListComponent";
import staticNft from '../../services/chainServices/staticNFT';
import useLocalStorage from "../../utils/useLocalStorage";

interface Props {
    active: Boolean;
}

const Address = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    color: #4A7DFF;
    margin-top: 26px;
    margin-bottom: 10px;
    border-radius: 16px;
    padding: 8px 12px;
    background: rgba(74, 125, 255, 0.04);
    width: fit-content;
`;

const Tab = styled.div<Props>`
    background: ${props => props.active ? '#FFFFFF' : 'transparent'};
    border-radius: 8px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    letter-spacing: 0.2px;
    color: ${props => props.active ? '#0E0F18' : '#fff'};
    padding: 6px;
    width: 100%;
`;

const TokenList = (props: any) => {
    const [activeTab, setActiveTab] = useLocalStorage(
        'active-tab-wallet', 'coin');
    const [showSeed, setShowSeed] = useState(false);

    const [address, setAddress] = useState('');
    const [activityData, setActivityData] = useState([]);
    const [currency, setCurrency] = useState(localStorage.getItem('glip-currency') || 'USD');
    const [btxBalance, setBtxBalance] = useState(0);

    const  {t} = useTranslation();
    
    useEffect(() => {
        let glipggToken: any = JSON.parse(
            localStorage.getItem(GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY) || '{}');
        setAddress(glipggToken.id)
    }, []);
        
    const logoutClicked = () => {
        GlipWalletGlobal.logout();
        props.setLoggedIn(false);
    }

    
    useEffect(() => {
        const fetchApi = async () => {
            let glipggToken: any = JSON.parse(localStorage.getItem(
                GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY) || '{}');
            const data: any = await getAssetTransfers(glipggToken.id);
            // console.log('activity data', data);
            setActivityData(data);
        }
        fetchApi();
    }, []);



    const changeCurrency = (currency: string) => {
        setCurrency(currency);
        // save currency to local storage
        localStorage.setItem('glip-currency', currency);
    }
        

    const RowItem = ({item, type}: any) => {
        if(item.symbol && item.symbol.toUpperCase() === 'BTX (UNLOCKED)') {
            //setBtxBalance(item.quantity);
        }
        
        return (
            <TokenListItemComponent
                key={item.id}
                item={item}
                type={type}
                currency={currency}
            />
        );
    }
    
    useEffect(() => {
        props.nonNFTTokensList.map((item: any, index: any) => {
            if(item.symbol && item.symbol.toUpperCase() === 'BTX (UNLOCKED)') {
                setBtxBalance(item.quantity);
            }
        })
    }, []);
    
    let cointListToIterate = props.nonNFTTokensList.filter((item: any) => {
        if(!item.symbol){
            return 0
        }
        const symbol = item.symbol.toLowerCase();
        const quantity = parseFloat(Number(item.quantity).toFixed(2));
        const hasBtxLockOrUnlock = symbol.includes('btx (lock)') || symbol.includes('btx (unlocked)');
        return quantity > 0 || hasBtxLockOrUnlock;
    });
    
    const coinlist = cointListToIterate.map((item: any, index: any) => {
        return (
            <RowItem type={'coin'} item={item} key={`row-item-token-${index}`}/>
        );
    })
    
    const nftlist = props.nftTokensList.map((item: any, index: any) => {
        return (
            <>
              <RowItem type={'nft'} item={item} key={`row-item-nft-${index}`}/>
            </>
        );
    })    
    
    const activitylist = activityData.map((item: any, index: any) => {
        return (
            <RowItem type={'activity'} item={item} key={`row-item-acitvity-${index}`}/>
        );
    })   

    useEffect(() => {
        if(showSeed) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [showSeed]);
    
    return (
        <div style={{display:'flex', flexDirection:'column',  backgroundColor:'#0F0F0F', padding: 20}}>
          
          <div style={{display: 'flex', justifyContent: 'flex-end'}}>
            <UserWalletOptionMenuComponent
                showSeedPhraseClicked={()=>{setShowSeed(true);}}
                logoutClicked={logoutClicked}
                activeCurrency={currency}
                changeCurrency={changeCurrency}
            />
          </div>

          <BalanceComponent
              nonNFTTokensList={props.nonNFTTokensList}
              nonNFTTokensListLen={props.nonNFTTokensList.length}
              currency={currency}
          >
          </BalanceComponent>
          <div style={{
              display: 'flex',
              justifyContent: 'center'}}>
            <Address style={{display: 'flex', justifyContent: 'center', }}>
              <span>0x...{address.substr(address.length - 14)}</span>
              <img onClick={() => copyText(address, t('Address copied'))} style={{marginLeft: 8}} src={copy} alt='copy icon' />
            </Address>
          </div>
          {/* <OffRampLinkComponent
              address={address}
              email={props.email}
              gc_balance={btxBalance}
          /> */}
          <div style={{
              display: 'flex',
              justifyContent: 'space-evenly',
              background: '#26283E',
              borderRadius: 8,
              padding: 3,
              marginTop: 20
          }}
          >
            <Tab className={'hover'} active={activeTab === 'coin'} onClick={() => {setActiveTab('coin');eventTracker('coin_tab_click', {})}}>{t('Coin')}</Tab>
            <Tab className="hover" active={activeTab === 'nft'} onClick={() => {setActiveTab('nft');eventTracker('nft_tab_click', {});}}>{t('NFTs')}</Tab>
            <Tab className="hover" active={activeTab === 'activity'} onClick={() => {setActiveTab('activity');eventTracker('activity_tab_click', {});}}>{t('Activity')}</Tab>                
          </div>
          
          <br></br>
          <>
            {activeTab === 'coin' && coinlist}
            {activeTab === 'nft' && (
                <>
                </>
            )}
            {activeTab === 'nft' && (
                <>
                  {nftlist}
                </>
            )}
            {activeTab === 'activity' && (
                <ActivityListComponent
                    activityItems={activityData}
                />)}
          </>
          
          {showSeed && <>
            <SeedPhraseComponent
                showSeed={showSeed}
                setShowSeed={setShowSeed}
            />
          </>
          }
        </div>
    );
    
}

export default TokenList;
